import * as React from 'react';
import { State } from '~/store/types';
import connect from '~/store/connect';
import AlertTable from '~/components/AlertTable';
import Alert from '~store/Alert/Alert';
import { SiteConfiguration } from '@watcherr/resources';

interface DashboardAlertListContainerProps {
  alerts: Alert[];
  getSiteConfig: () => Promise<SiteConfiguration>,
}

const DashboardAlertListContainer: React.FC<
  DashboardAlertListContainerProps
> = ({ alerts, getSiteConfig }) => {
  React.useEffect(() => {
    getSiteConfig().then((value) => {
      setSiteConfiguration(value['alarm-resolve-verification-mode'])
    })
    .catch((e) => console.log(e));   
  }, []);

  const [siteConfiguration, setSiteConfiguration] = React.useState<any>("");
  const combinedAlerts = [...alerts.filter((val) => val.isOpen), ...alerts.filter((val) => !val.isOpen).slice(0,15)];
  return (
    <AlertTable alerts={combinedAlerts} deviceVerification={siteConfiguration != "none"} />
  )
};

export default connect((state: State) => ({
  alerts: state.alerts.alertsSorted,
}))(DashboardAlertListContainer);
